// material-ui
import { styled, useTheme } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import {
    Avatar,
    Card,
    CardContent,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    Typography,
    Divider
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { secureLocalStorage } from "store/SecureStorage";

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LogoutIcon from '@mui/icons-material/Logout';
import LogoutSection from 'store/LogoutSection';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';

// styles
const CardStyle = styled(Card)(({ theme }) => ({
    background: theme.palette.primary.light,
    marginBottom: '22px',
    overflow: 'hidden',
    position: 'relative',
    '&:after': {
        content: '""',
        position: 'absolute',
        width: '157px',
        height: '157px',
        background: theme.palette.primary[200],
        borderRadius: '50%',
        top: '-105px',
        right: '-96px'
    }
}));

const MenuCard = () => {
    const theme = useTheme();
    const [version, setVersion] = useState('');
    const [logoutOpen, setLogoutOpen] = useState(false);

    const navigate = useNavigate();


    useEffect(() => {
        const savedOrg = secureLocalStorage.get('_or');
        if (savedOrg) {
            try {
                setVersion(savedOrg.version || '1.0.0');
            } catch (error) {
                console.error('Error parsing org from localStorage', error);
            }
        }
    }, []);

    const handleOpenLogoutDialog = () => {
        setLogoutOpen(true);
    };

    const handleCloseLogoutDialog = () => {
        setLogoutOpen(false);
    };

    const handleUpgradeClick = () => {
        navigate('/upgrade/plans');
    };


    return (
        <CardStyle>
            <CardContent sx={{ p: 2 }}>
                <List sx={{ p: 0, m: 0 }}>

                    <ListItem alignItems="flex-start" disableGutters sx={{ p: 0 }}>
                        <ListItemAvatar sx={{ mt: 0 }}>
                            <Avatar
                                variant="rounded"
                                sx={{
                                    ...theme.typography.commonAvatar,
                                    ...theme.typography.largeAvatar,
                                    color: theme.palette.primary.main,
                                    background: '#fff',
                                    marginRight: '12px'
                                }}
                            >
                                <InfoOutlinedIcon fontSize="inherit" />
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            sx={{ mt: 0 }}
                            primary={
                                <Typography variant="subtitle1" sx={{ color: theme.palette.primary[800] }}>
                                    Version
                                </Typography>
                            }
                            secondary={<Typography variant="caption"> {version}</Typography>}
                        />
                    </ListItem>
                </List>
            </CardContent>

            <LogoutSection
                open={logoutOpen}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleCloseLogoutDialog();
                    }
                }}
            />
        </CardStyle>
    );
};

export default MenuCard;
